/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.6.1",
  "gitBuildTime": "2026-03-25T12:36:49.668Z",
  "gitBuildVersion": "2.6.1",
  "gitCommitId": "d421186",
  "gitCommitIdFull": "d421186de47cb5b719116f4419df2fe69c6e27e9",
  "gitCommitTime": "2026-03-25T12:35:38.000Z",
  "version": "2.6.1-2026-03-25T12:35:38.000Z-(d421186)"
};
